import type { DealForecast } from '@openx/types/dealForecasting.ts';
import { type DealForecastAction, DealForecastActionType, type DealForecastState } from '@openx/types/store/deal.ts';

const initialDealForecastData: DealForecast = {
  ad_sizes: [],
  bid_guidance_high: 0,
  bid_guidance_low: 0,
  requests_with_targeting: 0,
  requests_without_targeting: 0,
  top_bundles: [],
  top_domains: [],
  us_cities: [],
  video_durations: [],
};

export const initialDealForecastState: DealForecastState = {
  deal_participants: [],
  disabled: true,
  forecast: initialDealForecastData,
};

export const dealForecastReducer = (
  state: DealForecastState = initialDealForecastState,
  action: DealForecastAction
): DealForecastState => {
  switch (action.type) {
    case DealForecastActionType.CANCEL_FORECAST:
      return initialDealForecastState;

    case DealForecastActionType.DEAL_FORECAST_PACKAGE_LOADING: {
      return {
        ...state,
        package_loading: action.package_loading,
      };
    }

    case DealForecastActionType.FORECAST_REQUEST_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };

    case DealForecastActionType.GET_JOB_ID_SUCCESS:
      return {
        ...state,
        audience_monthly_requests: action.audience_monthly_requests,
        contextual_estimate: action.contextual_estimate,
        job_id: action.job_id,
        not_included_fields: action.not_included_fields,
      };

    case DealForecastActionType.FORECAST_REQUEST_LOADING:
      return {
        ...state,
        loading: true,
      };

    case DealForecastActionType.FORECAST_REQUEST_SUCCESS:
      return {
        ...state,
        forecast: {
          ...state.forecast,
          ...action.forecast,
        } as DealForecast,
        loading: false,
      };

    case DealForecastActionType.FORECAST_UPDATE_DEAL_PARTICIPANTS:
      return {
        ...state,
        deal_participants: action.deal_participants,
      };

    case DealForecastActionType.GENERATE_FORECAST_BUTTON_DISABLED:
      return {
        ...state,
        disabled: action.disabled,
      };

    case DealForecastActionType.RESET_FORECAST:
      return {
        ...state,
        job_id: undefined,
      };

    default:
      return state;
  }
};
